import {HttpMethod, requestObject} from "../utils/http-request";
import {ApiOptions} from "./api-options";
import {HttpError} from "./http-error";

function fillPath(path: string, pathVariables?: object): string {
    if (!pathVariables) return path;
    let p = path;

    // :templateId などを置換（BigIntId など { value } を想定してダックタイピング）
    Object.entries(pathVariables).forEach(([k, v]) => {
        const val =
            v && typeof v === "object" && "value" in (v as any)
                ? String((v as any).value)
                : String(v);
        p = p.replace(new RegExp(`:${k}(?=/|$)`, "g"), encodeURIComponent(val));
    });

    return p;
}
/**
 * エラーハンドリングを含むリクエストオブジェクトの非同期関数。
 *
 * @template TOutput - 出力データの型。
 * @param {HttpMethod} method - HTTPメソッド。
 * @param {string} path - エンドポイントパス。
 * @param {new () => TOutput} outputClass - レスポンスデータのデシリアライズクラス。
 * @param {object} [pathVariables] - パス変数。
 * @param {object} [inputObject] - リクエストの入力データ。
 * @param {ApiOptions} apiOptions - APIオプション。
 * @param {object} [queryVariables] - クエリ変数。
 * @returns {Promise<TOutput>} - レスポンスデータのPromise。
 * @throws - リクエスト中にエラーが発生した場合にスローされます。
 */
export async function requestObjectErrorHandled<TOutput extends object>(
    method: HttpMethod,
    path: string,
    outputClass: new () => TOutput,
    pathVariables: object | undefined,
    inputObject: object | undefined,
    apiOptions: ApiOptions,
    queryVariables?: object,
) {
    try {
        return await requestObject(
            method,
            path,
            outputClass,
            pathVariables,
            inputObject,
            await apiOptions.getRequestOptions(),
            queryVariables,
        );
    } catch (e: any) {
        // ← ここで path だけを付与して再throw
        const err = e instanceof HttpError ? e : new HttpError(e?.message ?? "Request failed", "");
        if (!err.path) {
            err.path = fillPath(path, pathVariables); // 例: "/api/.../templates/75"
        }

        apiOptions.handleError(err); // ここで ToastStore.setHttpError(err) が呼ばれる想定
        throw err;
    }
}
